module.exports = __webpack_public_path__ + "shop-report.svg?09eceb09121ca1601d04b5e41f132008";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shop-report.svg
// module id = 324
// module chunks = 2